import { placeholders, displayGroups } from '@ui';

import { TouchPointHelper } from '../../../helpers/touchPointHelper';

export const accessDenied = {
	prismName: 'accessDenied',
	template: {
		templateName: 'accessDeniedTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.lateralMenu, {
								placeholderBuildReference: 10,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.accessDenied, {
										placeholderBuildReference: 100,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 1001,
							}),
						]
					),
				]),
			]),
		],
	},
};
